import { OrderModel } from "@app/interfaces/order";
import React from "react";
import ListImages from "../components/ListImages";

interface OrderInfoProps {
  record: OrderModel;
}

const OrderDeliveredImages: React.FC<OrderInfoProps> = ({ record }) => {
  
  return (
    <ListImages
      record={record}
      assetType="delivered"
      description="Hình ảnh sản phẩm giao hàng cho khách"
    />
  )
}

export default OrderDeliveredImages;